/**
 * 基础配置信息 呼叫转接
 * @type {{appId: string, source: string}}
 */
export const config = {
  appId: "1770982630",
  source: "20221214095858288212000000010001",
};
